module.exports = __webpack_public_path__ + "static/img/logo-yi.e4b5df36.f24f7f31.png";